import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/chat/StarterLanding.tsx
// The empty-chat landing for Luna. A welcoming, designed screen — greeting +
// a curated, profile-ranked grid of starter cards. Clicking a card sends that
// prompt immediately.
//
// Distinct from the in-composer type-ahead panel (PromptSuggestions.tsx),
// which only appears while the user is typing or focused mid-conversation.
// Recents live in the left conversation rail and in the type-ahead, so the
// landing stays curated and uncluttered.
import { useMemo } from "react";
import { TrendingUp, PieChart, PiggyBank, Receipt, ShieldAlert, Target, Globe, Shield, Brain, Sparkles, } from "lucide-react";
import { landingCapabilities } from "../../lib/promptSuggestions";
const GROUP_ICON = {
    "Trade Ideas": TrendingUp,
    Portfolio: PieChart,
    Retirement: PiggyBank,
    Taxes: Receipt,
    "Risk & What-Ifs": ShieldAlert,
    "My Goals": Target,
    "Markets & Economy": Globe,
    Insurance: Shield,
    "Habits & Blind Spots": Brain,
};
export function StarterLanding({ profile, onPick, compact }) {
    const cards = useMemo(() => landingCapabilities(profile, 6), [profile]);
    return (_jsxs("div", { className: "w-full max-w-2xl mx-auto flex flex-col items-center", children: [!compact && (_jsxs(_Fragment, { children: [_jsx("span", { className: "text-3xl text-violet-400/80 mb-3 select-none", children: "\u2726" }), _jsx("p", { className: "text-base text-slate-300 mb-1 text-center", children: "What would you like to work on?" }), _jsx("p", { className: "text-xs text-slate-600 mb-5 md:mb-6 text-center px-4", children: "Pick a starting point, or just ask Luna anything below." })] })), _jsx("div", { className: "grid grid-cols-2 lg:grid-cols-3 gap-2.5 sm:gap-3 w-full", children: cards.map((c) => {
                    const Icon = GROUP_ICON[c.group] ?? Sparkles;
                    return (_jsxs("button", { type: "button", onClick: () => onPick(c.prompt), className: "text-left flex flex-col gap-1.5 bg-slate-900 border border-slate-800/60 rounded-xl p-3 sm:p-4 hover:bg-slate-800/60 hover:border-slate-700 transition-colors", children: [_jsx(Icon, { size: 18, className: "text-violet-400 shrink-0" }), _jsx("span", { className: "text-[13px] sm:text-sm font-medium text-slate-200 leading-snug", children: c.label }), _jsx("span", { className: "hidden sm:block text-xs text-slate-500 leading-snug", children: c.description })] }, c.id));
                }) })] }));
}
